import { render } from "./SkillRow.vue?vue&type=template&id=543496f4"
import script from "./SkillRow.vue?vue&type=script&lang=js"
export * from "./SkillRow.vue?vue&type=script&lang=js"
script.render = render

export default script